import React from 'react';
import ReactDOM from 'react-dom';
import './styles/grid.css'; // Import grid CSS for layout
import App from './App';

// Render the main App component into the DOM
ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);
